import React, {Component} from 'react'
import ShippedModal from "./ShippedModal"
import {Button} from "reactstrap"

class Shipped extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    render() {
        const {isOpen} = this.state

        return (
            <div className="Shipped">
                <Button onClick={this._handleToggleModal} color="warning" size="sm">
                    Đã nhận
                </Button>
                <ShippedModal
                    {...this.props}
                    isOpen={isOpen}
                    onToggleModal={this._handleToggleModal}
                />
            </div>
        )
    }
}

export default Shipped